import React from 'react';
import { PURCHASE_ORDER_STATUS_PERMISSION } from 'pages/PurchaseOrderStatus/utils/constants';

const PurchaseOrderStatusPage = React.lazy(() => import('pages/PurchaseOrderStatus/PurchaseOrderStatusPage'));
const PurchaseOrderStatusAddPage = React.lazy(() => import('pages/PurchaseOrderStatus/PurchaseOrderStatusAddPage'));

const routes = [
  {
    path: '/purchase-order-status',
    exact: true,
    name: 'Danh sách trạng thái đơn mua hàng',
    function: PURCHASE_ORDER_STATUS_PERMISSION.VIEW,
    component: PurchaseOrderStatusPage,
  },
  {
    path: '/purchase-order-status/add',
    exact: true,
    name: 'Thêm trạng thái đơn mua hàng',
    function: PURCHASE_ORDER_STATUS_PERMISSION.ADD,
    component: PurchaseOrderStatusAddPage,
  },
  {
    path: '/purchase-order-status/edit/:scope/:id',
    exact: true,
    name: 'Chỉnh sửa trạng thái đơn mua hàng',
    function: PURCHASE_ORDER_STATUS_PERMISSION.EDIT,
    component: PurchaseOrderStatusAddPage,
  },
  {
    path: '/purchase-order-status/detail/:scope/:id',
    exact: true,
    name: 'Chi tiết trạng thái đơn mua hàng',
    function: PURCHASE_ORDER_STATUS_PERMISSION.VIEW,
    component: PurchaseOrderStatusAddPage,
  },
];

export default routes;
